import ActionTypes from '../constants/actionTypes'

const initialState = {
  loading: false,
  brands: [],
}

export default function brands(state = initialState, action) {
  let { payload } = action
  switch (action.type) {
    case ActionTypes.GET_BRAND.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case ActionTypes.GET_BRAND.SUCCESS:
      return {
        ...state,
        brands: [...payload.data],
        loading: false,
      }
    case ActionTypes.GET_BRAND.FAILURE:
      return {
        ...state,
        loading: false,
      }
    case ActionTypes.FORMAT_BRAND.REQUEST:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
